import React from 'react';

interface CalculatingPriceStateProps {
    /** Optional override for the transitional message. */
    message?: string;
    className?: string;
}

// How long it can take is the time limit of the analyses (one minute); the wording is fixed.
const HINT = 'Complex files can take up to a minute.';

const SKELETON_ROWS = 2;
const BARS_PER_ROW = ['lead time', 'unit price', 'total price'];

/**
 * Transitional state shown while the analyses that decide FastLane and Standard eligibility
 * are running (the async brep-explorer/SFA analysis). It draws the shape of the price rows that
 * are about to appear, so the layout does not jump when they land, and it keeps the manual-quote
 * fallback from flashing meanwhile.
 *
 * Kept local to one-true-form because the shared common-features package is not
 * built to `lib/` and this package is compiled with plain `tsc`.
 */
export const CalculatingPriceState: React.FC<CalculatingPriceStateProps> = ({
    message = 'Calculating prices…',
    className = '',
}) => (
    <div
        aria-live="polite"
        className={`calculating-price-state ${className}`.trim()}
        data-testid="calculating-price-state"
        role="status"
    >
        <div aria-hidden="true" className="calculating-price-state-rows">
            {Array.from({ length: SKELETON_ROWS }, (_, row) => (
                <div className="calculating-price-state-row" key={row}>
                    {BARS_PER_ROW.map(bar => (
                        <span className="calculating-price-state-bar" key={bar} />
                    ))}
                </div>
            ))}
        </div>
        <div className="calculating-price-state-note">
            <span aria-hidden="true" className="calculating-price-state-dot" />
            {message}
        </div>
        <div className="calculating-price-state-hint" data-testid="calculating-price-state-hint">
            {HINT}
        </div>
    </div>
);
